import React, { Component } from "react";
import { getQueryParam } from "../../../managers/common/CommonUtil";
import ComponentImportManager from "./ComponentImportManager";
import {
    showToast,
    DKButton,
    TOAST_TYPE,
    showLoader,
    DKLabel,
    removeLoader,
} from "deskera-ui-library";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import { convertToCSV, getImportRecords } from "../../import_export/utility/ImportUtility";
import Stepper from "../../common/Stepper";
import { importOptions } from "../../import_export/EximConstants";
import { COUNTRY } from "../../../constants/CountryConstant";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";
import ImportService from "../../import_export/service/Import";
import Utility from "../../../utility/Utility";
import ComponentListService from "../../../services/ComponentListService";

class ComponentValueImportPortal extends Component {
    constructor(props) {
        super(props);
        this.tableName = getQueryParam(this.props.location, "module");
        this.source = getQueryParam(this.props.location, "origin");
        this.steps = ComponentImportManager.getAllCreationSteps(this.onSkipToStep);
        this.state = {
            currentStep: 0,
            auditLogId: "",
            fileInfo: null,
            fileContent: null,
            mappedHeaders: null,
            importRecords: null,
            invalidRows: null,
            selectedSegmentId: [],
            importProperties: JSON.parse(importOptions),
            components: null
        };
    }

    componentDidMount() {
        RouteManager.setPresenter(this);

        /* TableName Query Param is required to proceed */
        if (!this.tableName) {
            RouteManager.navigateToPage(this.source || "/");
        }

        this.fetchDependencies();
    }

    async fetchDependencies() {
        showLoader();

        const response = await ComponentListService.getAllComponent();
        if (response) {
            let components = null;

            if (Array.isArray(response?.components)) {
                components = response.components.map((component) => {
                    return {
                        id: component.id,
                        name: component.name,
                        type: component.type,
                        subType: component.subType,
                        isVariable: component.isVariable,
                        isFormula: component.isFormula,
                        includeInCTC: component.includeInCTC,
                        componentConfig: component.componentConfig,
                        isActive: component.isActive
                    };
                });
            }

            this.setState({
                components: components
            });
        }

        removeLoader();
    }

    onSkipToStep = (event, index) => {
        const { currentStep } = this.state;

        /* By default expected step is to move forward */
        const expectedStep = index ?? currentStep + 1;

        /* If it's the last step */
        if (expectedStep === this.steps.length) {
            if (this.state.invalidRows && this.state.invalidRows.length) {
                showToast(this.steps[currentStep].reqError, TOAST_TYPE.FAILURE);
            } else {
                this.handleImportConfirmation();
            }
            return;
        }

        if (this.isInvalidStep(expectedStep)) {
            const errorInfo =
                this.steps[currentStep].reqError ||
                `Sorry can't proceed, please complete the current step first`;
            showToast(errorInfo, TOAST_TYPE.FAILURE);
        } else {
            this.setState({ currentStep: expectedStep });
        }
    };

    handleImportConfirmation() {
        let fileName = this.state.fileInfo.name;
        fileName = fileName.replace(/\.[^/.]+$/, "") + ".csv";
        const mapping = this.state.mapping.map((header) => {
            return {
                colHeader: header.colHeader,
                displayName: header.displayName,
                fieldName: header.fieldName
            }
        });

        const importRecords = getImportRecords(this.state.importRecords, this.state.mappedHeaders);
        importRecords.forEach((row) => {
            Object.keys(row).forEach((key) => {
                mapping.forEach((map) => {
                    if (map.fieldName === key && Utility.isEmpty(map.colHeader)) {
                        map.colHeader = key;
                    }
                });
            });
        });

        const csvFile = new File([convertToCSV(importRecords)], fileName);

        showLoader("Processing... Please wait");
        ComponentImportManager.getUploadFileRelativeURL(csvFile).then(
            (filePath) => {
                const payload = {
                    dataInsight: {
                        dateFormat: this.getDatFormats(),
                    },
                    mapping: mapping
                };

                const queryParam = {
                    module: "PEOPLE_COMPONENT",
                    relativeFilePath: filePath,
                    auditLogId: this.state.auditLogId,
                };

                ImportService.import(payload, queryParam).then(
                    (response) => {
                        removeLoader();
                        this.showImportMessage(response);
                    },
                    (error) => {
                        removeLoader();
                        showToast(
                            "Something went wrong while importing records.",
                            TOAST_TYPE.FAILURE
                        );
                    }
                );
            }
        );
    }

    getDatFormats = () => {
        const country = TenantService.get(TENANT.COUNTRY_CODE);
        switch (country) {
            case COUNTRY.US:
                return "MM/dd/yyyy";
            case COUNTRY.IN:
                return "dd/MM/yyyy";
            default:
                return "dd/MM/yyyy";
        }
    };

    handleStepData = (data, callback) => {
        this.setState({ ...data }, callback);
    };

    isInvalidStep = (expectedStep) => {
        if (expectedStep < 0 || expectedStep >= this.steps.length) return false;

        /* Check if component has required data for expected step */
        const { requiredProps } = this.steps[expectedStep];
        return requiredProps.some(
            (requiredProp) => this.state[requiredProp] === null
        );
    };

    getCurrentStepChild() {
        const currStep = this.steps[this.state.currentStep];
        return currStep.getChild({
            state: this.state,
            tableName: this.tableName,
            setData: this.handleStepData,
        });
    }

    navigateToPage() {
        RouteManager.navigateToPage(PAGE_ROUTES.COMPONENT);
    }

    getControllers() {
        const { fileInfo, currentStep } = this.state;
        const isLastStep = currentStep === this.steps.length - 1;
        return (
            <div className="row parent-width justify-content-center mb-l">
                {
                    <DKButton
                        title="Cancel"
                        className="border-m ml-r bg-white"
                        onClick={(e) => this.navigateToPage()}
                    />
                }
                {currentStep !== 0 && (
                    <DKButton
                        title="Back"
                        className="border-m ml-r bg-white"
                        onClick={(e) => this.onSkipToStep(e, currentStep - 1)}
                    />
                )}
                {fileInfo && (
                    <DKButton
                        title={!isLastStep ? "Continue" : "Save"}
                        className="border-m ml-r bg-app text-white"
                        onClick={this.onSkipToStep}
                    />
                )}
            </div>
        );
    }

    showImportMessage = (data) => {
        if (Array.isArray(data["success"]) && data["success"].length > 0) {
            if (data["failed"].length) {
                showToast(`Successful Import: ${data["success"].length}, Rejected Records: ${data["failed"].length}.`, TOAST_TYPE.SUCCESS);
            } else {
                showToast("Earnings and Deductions values imported successfully.", TOAST_TYPE.SUCCESS);
            }
        } else if (data["Bulk_Import"]) {
            showToast("Import is in progress, we will notify you once done.", TOAST_TYPE.SUCCESS);
        } else {
            showToast("Import Unsuccessful, some or all of the records were not imported properly.", TOAST_TYPE.FAILURE);
        }

        RouteManager.navigateToPage(this.source);
    }

    render() {
        return (
            <>
                <div className="column parent-width">
                    <DKLabel text="Import Component Values" className="fw-m fs-l mb-r" />
                    <Stepper
                        data={this.steps}
                        currentIndex={this.state.currentStep}
                        className="mb-l"
                    />

                    <div className="row parent-width m-v-xl justify-content-center">
                        {this.getCurrentStepChild()}
                    </div>

                    {this.getControllers()}
                </div>
            </>
        );
    }
}

export default ComponentValueImportPortal;
